<template>
  <div class="page-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="btn" @click="handleBusinessModal('add')">+ 添加商家</div>
        <el-table
          :data="businessList"
          class="table no-border-table"
          ref="table"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            type="index"
            :index="tableIndex"
            align="center"
            label="序号"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="name"
            align="center"
            label="商品商家名称"
          ></el-table-column>
          <el-table-column
            prop="phone"
            align="center"
            label="联系电话"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="240">
            <div slot-scope="scope" style="width: 100%;display: flex;justify-content: center;">
              <!-- <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="updateNoDeliver(scope.row.id)"
                >
                  不发货地区
                </button>
              </div> -->
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="handleBusinessModal('edit', scope.row)"
                >
                  编辑
                </button>
              </div>
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deleteBusiness(scope.row.id)"
                >
                  删除
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="addShow" class="dialog" width="560px" top="25vh">
      <div slot="title" class="dialog-title">
        {{ (type === "add" ? "添加" : "编辑") + "商家" }}
      </div>
      <el-form
        ref="form"
        :rules="rules"
        :model="addForm"
        class="form"
        label-width="auto"
      >
        <el-form-item label="商家名称：" prop="sort" class="form-item">
          <el-input
            placeholder="请输入商家名称"
            class="add-renovation-input"
            style="width: 160px"
            v-model="addForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="sort" class="form-item">
          <el-input
            placeholder="请输入联系电话"
            class="add-renovation-input"
            style="width: 160px"
            v-model="addForm.phone"
            type="number"
            onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="addShow = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleConfirm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 修改排序弹窗 -->
    <!-- <el-dialog title="更改排序" width="400px" :visible.sync="sortShow">
      <el-form label-width="60px" size="mini" ref="editSort" inline-message>
        <el-form-item label="排序：" prop="tableData" style="margin-top: 15px">
          <el-input v-model="currentSort" type="number" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="sortShow = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="saveSort">确 定</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '商品商家列表'
      },
      businessList: [], // 轮播列表
      rules: {},
      sortShow: false,
      currentSort: 0,
      addForm: {
        name: '',
        phone: null
      },
      addShow: false,
      businessId: null,
      type: ''
    };
  },
  mounted() {
    // 获取列表
    this.getList();
  },
  computed: {},
  methods: {
    // 表格序号
    tableIndex(index) {
      return ++index;
    },
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    // 获取列表
    getList() {
      this.loading++;
      this.httpGet(this.$root.getBusinessList, {
        page: this.currentPage,
        size: this.size
      }).then(
        (res) => {
          this.loading--;
          this.businessList = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    updateNoDeliver(id) {
      this.$router.push({
        name: 'noDeliver',
        query: {
          id
        }
      });
    },
    // 编辑轮播弹窗
    handleBusinessModal(type, rowData) {
      this.type = type;
      if (type === 'edit') {
        this.businessId = rowData.id;
        this.addForm = {
          phone: rowData.phone,
          name: rowData.name
        };
      } else {
        this.addForm = {
          phone: null,
          name: ''
        };
        this.$refs.form && this.$refs.form.clearValidate();
      }
      this.addShow = true;
    },
    // 删除
    deleteBusiness(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该商家吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteBusiness, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    //
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let url =
            this.type === 'add'
              ? this.$root.addBusiness
              : this.$root.updateBusiness;
          let method = this.type === 'add' ? 'httpPost' : 'httpPut';
          let inputData =
            this.type === 'add'
              ? {
                  ...this.addForm
                }
              : {
                  ...this.addForm,
                  id: this.businessId
                };
          this.loading++;
          this[method](url, inputData).then(
            (res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.loading--;
              this.addShow = false;
              this.getList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        }
      });
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.page-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        // width: 100px;
        display: inline-block;
        padding: 0 10px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        // margin: 16px 0;
      }

      .tip {
        margin-left: 32px;
        color: #999;
      }

      // 表格按钮
      .table-btn {
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
        padding: 0 6px;
        min-width: 80px;
        width: auto;
        box-sizing: border-box;
      }

      .table-img {
        height: 36px;
        width: auto;
      }
    }
  }

  .dialog-content {
    flex-y();
  }

  .addImg {
    .icon {
      width: 80px;
      height: 80px;
    }
  }

  .form {
    margin-top: 16px;
    margin-bottom: 20px;
    // padding-left: 60px;
    flex-y(flex-start, center);

    .sort-tip {
      word(14px, #c8c8c8);
      line-height: 20px;
    }
  }
  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }
}
</style>
